import classNames from 'classnames';
import Image from '@alltrails/core/components/Image';
import Link from '@alltrails/denali/components/Link';
import Logo from '@alltrails/denali/components/Logo';
import { BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import SponsoredBadge from '@/components/shared/SponsoredBadge';
import { PostStatus } from '@/types/shared';
import styles from './styles.module.scss';

type NewsroomCardProps = {
  thumbnail?: string;
  category?: string;
  title: string;
  date: string;
  href: string;
  is_sponsored: boolean;
  status: PostStatus;
};

const NewsroomCard = ({ thumbnail, category, title, date, href, is_sponsored, status }: NewsroomCardProps) => {
  const isUnpublished = status !== 'publish';

  return (
    <article className={classNames(styles.container, { [styles.unpublished]: isUnpublished })}>
      <div className={styles.imageContainer}>
        <Link href={href} noUnderline>
          {thumbnail ? (
            <Image
              alt={title}
              src={thumbnail}
              loading="lazy"
              className={styles.thumbnail}
              fill
              sizes={`(max-width: ${BREAKPOINT_SM_SIZE}) 100vw, 400px`}
            />
          ) : (
            <div className={classNames(styles.thumbnail, styles.missingImagePlaceholder)}>
              <Logo size="md" variant="logomark" color="colored-light" />
            </div>
          )}
        </Link>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.category}>{category}</div>
        <h3 className={styles.title}>
          <Link href={href} noUnderline>
            {title}
          </Link>
        </h3>
        {is_sponsored && <SponsoredBadge />}
        {isUnpublished && <span className={styles.statusBadge}>{status}</span>}
        <div className={styles.date}>{date}</div>
      </div>
    </article>
  );
};

export default NewsroomCard;
